/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Hero_Coaches_OtherInputs */

const en_hero_coaches_other = /** @type {(inputs: Hero_Coaches_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} coaches`)
};

const pl_hero_coaches_other = /** @type {(inputs: Hero_Coaches_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} trenerów`)
};

/**
* | output |
* | --- |
* | "{count} coaches" |
*
* @param {Hero_Coaches_OtherInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const hero_coaches_other = /** @type {((inputs: Hero_Coaches_OtherInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Coaches_OtherInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_hero_coaches_other(inputs)
	return en_hero_coaches_other(inputs)
});